import { Grid, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useUser } from '../../Hooks/useUser';
import { ConnectWallet } from './Components/ConnectWallet';
import { Transactions } from './Components/Transactions';

export const Wallet = () => {
    /* ******************** Hooks ******************** */
    const { hasDefaultPaymentMethod } = useUser();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const getView = useCallback(() => {
        switch(true) {
            case hasDefaultPaymentMethod:
                return <Transactions />;
            default:
                return <ConnectWallet />;
        }
    }, [hasDefaultPaymentMethod])
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid
            paddingLeft={6}
            paddingTop={9}
            width={"100%"}
            height={"100%"}
        >
            <Typography variant='lora-headline-small'>Payments</Typography>
            {getView()}
        </Grid>
    )
}